import React from 'react';
import { Box } from '@mui/material';
import RelatedSectionShell, { TilesGrid } from './RelatedSectionShell';

// Use the same tile component you use on the dashboard for Products
import ProductTile from '../tiles/ProductForJobTile';

import ProductsTable from './tables/ProductsTable';

const findProductsSection = (sections) =>
  (sections || []).find((s) =>
    s?.title && /how well products do this job/i.test(String(s.title))
  ) || null;

const sectionTotalFrom = (sec) =>
  sec?.section_total_interviews ?? sec?.sectionTotal ?? 0;

export default function RelatedProducts({ sections, customerStories = [], jobName }) {
  const productsSec = React.useMemo(() => findProductsSection(sections), [sections]);
  if (!productsSec) return null;

  const tiles = Array.isArray(productsSec.tiles) ? productsSec.tiles : [];
  const top3 = tiles.slice(0, 3);

  return (
    <RelatedSectionShell section={productsSec}>
      {/* Top-3 tiles (same visuals as dashboard) */}
      <Box sx={{ mb: 2 }}>
        <TilesGrid
          tiles={top3}
          renderTile={(t) => (
            <ProductTile {...t} sectionTotal={sectionTotalFrom(productsSec)} />
          )}
        />
      </Box>

      {/* Full ranked table */}
      <ProductsTable
        rowsSource={tiles}
        customerStories={customerStories}
        jobName={jobName}
        sectionTotal={sectionTotalFrom(productsSec)}
      />
    </RelatedSectionShell>
  );
}
